import React from "react"
import Layout from "../components/layout"
import { graphql, Link } from "gatsby"
import { Container } from "reactstrap"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import Seo from "../components/seo"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import BackgroundImage from "gatsby-background-image"
// const slugify = require("slugify")

const Blogs = props => {
  const { data } = props
  const { numPosts } = props.pageContext

  // console.log(props.pageContext)
  return (
    <Layout>
      <Seo
        title="Latest Posts"
        description={data.site.siteMetadata.description}
      />
      <div className="page-headline blog-page">
        <div className="container">
          <div className="section-heading text-center">
            <h6 className="font-weight-bold text-uppercase flair">Blog</h6>
            <h1>
              <strong>Latest Posts</strong>
            </h1>
          </div>
        </div>
      </div>
      <div className="blog-section">
        <Container>
          <div className="row justify - content - between">
            {data.allSanityPost.edges.map(blog => {
              const ggimage = getImage(
                blog.node.mainImage !== null
                  ? blog.node.mainImage.asset.gatsbyImageData
                  : "https://source.unsplash.com/pencil/joshhild/500x500"
              )
              const convertggimage = convertToBgImage(ggimage)
              return (
                <LazyLoadComponent>
                  <div className="col-md-4 mb-5">
                    <div className="blog-item mb-4 h-100" key={blog}>
                      <Link
                        title="blog item"
                        to={`/blog/${blog.node.slug.current}`}
                      >
                        <BackgroundImage
                          Tag="div"
                          className="blog-image"
                          {...convertggimage}
                          style={{
                            // backgroundImage: `url(${
                            //   blog.node.mainImage !== null
                            //     ? blog.node.mainImage.asset.fluid.src
                            //     : "https://source.unsplash.com/user/joshhild/500x500"
                            // })`,
                            "background-size": `cover`,
                          }}
                        />
                      </Link>
                      <div className="blog-text p-4">
                        <Link
                          title="blog item"
                          to={`/blog/${blog.node.slug.current}`}
                        >
                          <h4 className="mb-3">{blog.node.title}</h4>
                        </Link>
                        <div className="text-muted small mb-3">
                          {blog &&
                          blog.node &&
                          blog.node.categories &&
                          blog.node.categories.length !== 0
                            ? blog.node.categories.map(ct => (
                                <span>
                                  <i className="fa fa-folder pr-1" />
                                  {ct.title + " "}
                                </span>
                              ))
                            : null}
                        </div>
                        <p className="pt-2 text-muted">{blog.node.excerpt}</p>
                        <span className="text-muted small">
                          <i className="fa fa-calendar-o pr-1" />
                          {blog.node.publishedAt}
                        </span>
                      </div>
                    </div>
                  </div>
                </LazyLoadComponent>
              )
            })}
          </div>
          <div className="d-flex justify-content-center align-items-center mt-4">
            {/*      {!isFirst && (
              <Link
                className="prevPage hvr-shadow d-none d-md-inline"
                to={prevPage}
                rel="prev"
              ></Link>
            )}*/}
            <ul className="list-unstyled d-flex mb-0 pagination-number text-truncate">
              {Array.from({ length: numPosts }, (_, i) => (
                <li>
                  <Link
                    title="blog items paginate"
                    activeClassName="current"
                    key={`pagination-number${i + 1}`}
                    to={`/blog/${i === 0 ? "" : i + 1}`}
                  >
                    {i + 1}
                  </Link>
                </li>
              ))}
            </ul>
            {/*            {
                !isLast && (
                    <Link
                className="nextPage hvr-shadow d-none d-md-inline"
                to={nextPage}
                rel="next"
              >
                <i className="fas fa-angle-right" />
              </Link>
                )
            }*/}
          </div>
        </Container>
      </div>
    </Layout>
  )
}

export default Blogs

export const blogQuery = graphql`
  query blogQuery($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
    allSanityPost(
      sort: { fields: [publishedAt], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          title
          excerpt
          body
          publishedAt(formatString: "MMMM DD, YYYY")
          mainImage {
            asset {
              gatsbyImageData(
                placeholder: BLURRED
                layout: CONSTRAINED
                fit: FILL
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          slug {
            current
          }
          categories {
            title
          }
        }
      }
      group(field: categories___title) {
        fieldValue
      }
    }
  }
`
